/* Misy Jewelry Enhancements v2.3 - 2026-05-10 (Codex 3rd review fixes) */
(function(){
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ============ 1. SCROLL-TRIGGER ANIMATIONS ============ */
  function initScrollTrigger(){
    if (prefersReducedMotion) { revealAll(); return; }
    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    var els = document.querySelectorAll('.misy-scroll-trigger');
    if (els.length){
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e, i){
          if (e.isIntersecting){
            var t = e.target;
            t.classList.remove('misy-scroll-trigger--offscreen');
            if (t.hasAttribute('data-misy-cascade')){
              t.style.setProperty('--misy-animation-order', i);
            }
            obs.unobserve(t);
          }
        });
      }, { rootMargin: '0px 0px -50px 0px' });
      els.forEach(function(el){
        el.classList.add('misy-scroll-trigger--offscreen');
        obs.observe(el);
      });
    }

    var sectionSelectors = [
      '.shopify-section--related-products',
      '.shopify-section--complementary-products',
      '.shopify-section[id*="related"]',
      '.shopify-section[id*="trust"]',
      '.shopify-section[id*="journal"]',
      '.shopify-section[id*="ugc"]',
      '.shopify-section[id*="reviews"]'
    ];
    var sectionEls = document.querySelectorAll(sectionSelectors.join(','));
    if (sectionEls.length){
      var sectionObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            e.target.classList.add('misy-in-view');
            sectionObs.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      sectionEls.forEach(function(el){ sectionObs.observe(el); });
    }
  }

  function revealAll(){
    document.querySelectorAll('.misy-scroll-trigger').forEach(function(el){
      el.classList.remove('misy-scroll-trigger--offscreen');
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    document.querySelectorAll('.shopify-section--related-products, .shopify-section--complementary-products, .shopify-section[id*="related"], .shopify-section[id*="trust"], .shopify-section[id*="journal"], .shopify-section[id*="ugc"], .shopify-section[id*="reviews"]').forEach(function(el){
      el.classList.add('misy-in-view');
    });
  }

  setTimeout(revealAll, 2000);

  /* ============ 2. AI BUNDLE CART (Codex 3rd review fixes) ============
     - Reads CURRENT main variant ID from product form
     - Uses Shopify.routes.root
     - Cart drawer: tries Prestige show() / open() / openCartDrawer() / cart trigger click
     - Skips unavailable bundle items, surfaces errors
  */
  function getCurrentMainVariantId(btn){
    var bundleEl = btn.closest('[data-misy-bundle]') || btn.closest('product-recommendations') || document;
    var product = bundleEl.closest && bundleEl.closest('.product, .product-info, [data-product-id]');
    var scope = product || document;
    /* Prefer the main product form (not Shop Pay/installments forms) */
    var forms = scope.querySelectorAll('form[action*="/cart/add"]:not([id*="installment"]):not([id*="shop-pay"])');
    for (var i = 0; i < forms.length; i++){
      var input = forms[i].querySelector('[name="id"]:not([disabled])');
      if (input && input.value) return input.value;
    }
    /* Fallback to Liquid-rendered value (may be stale on variant change) */
    return btn.getAttribute('data-misy-main-id');
  }

  function tryOpenCartDrawer(){
    /* Prestige & similar: try multiple known APIs */
    var drawer = document.querySelector('cart-drawer, mini-cart, cart-notification, [data-cart-drawer]');
    if (drawer){
      /* Prestige theme uses .show() on cart-drawer custom element */
      if (typeof drawer.show === 'function'){ try { drawer.show(); return true; } catch(e){} }
      /* Other themes use .open() */
      if (typeof drawer.open === 'function'){ try { drawer.open(); return true; } catch(e){} }
      /* Some custom impls */
      if (typeof drawer.openCartDrawer === 'function'){ try { drawer.openCartDrawer(); return true; } catch(e){} }
    }
    /* Try clicking a visible cart toggle button (header cart icon) */
    var trigger = document.querySelector('[aria-controls*="cart"][aria-haspopup], button[data-cart-trigger], a[href$="/cart"][data-cart-toggle]');
    if (trigger && trigger.offsetParent !== null){
      try { trigger.click(); return true; } catch(e){}
    }
    /* Prestige PUB_SUB pattern */
    if (window.PUB_SUB_EVENTS && window.publish){
      try {
        if (window.PUB_SUB_EVENTS.cartUpdate){
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'misy-bundle', open: true });
        }
        if (window.PUB_SUB_EVENTS.cartOpen){
          window.publish(window.PUB_SUB_EVENTS.cartOpen, {});
          return true;
        }
      } catch(e){}
    }
    return false;
  }

  function initBundleCart(){
    document.addEventListener('click', function(ev){
      var btn = ev.target.closest('[data-misy-bundle-add]');
      if (!btn) return;
      ev.preventDefault();

      var mainId = getCurrentMainVariantId(btn);
      var bundleIds = (btn.getAttribute('data-misy-bundle-ids') || '').split(',').filter(Boolean);

      if (!mainId || bundleIds.length === 0) {
        console.warn('[Misy Bundle] missing variant IDs', { mainId: mainId, bundleIds: bundleIds });
        return;
      }

      var allIds = [mainId].concat(bundleIds);
      var items = allIds.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });

      btn.disabled = true;
      var origText = btn.textContent;
      btn.textContent = '追加中...';

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res){
        return res.json().then(function(data){ return { ok: res.ok, status: res.status, data: data }; });
      })
      .then(function(result){
        if (!result.ok) {
          var msg = (result.data && (result.data.description || result.data.message)) || ('cart add failed: ' + result.status);
          throw new Error(msg);
        }
        btn.textContent = '追加しました ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.PUB_SUB_EVENTS && window.publish && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'misy-bundle' });
        }
        var drawerOpened = tryOpenCartDrawer();
        if (!drawerOpened){
          setTimeout(function(){ window.location.href = ROOT + 'cart'; }, 800);
        } else {
          setTimeout(function(){ btn.textContent = origText; btn.disabled = false; }, 1500);
        }
      })
      .catch(function(err){
        console.error('[Misy Bundle]', err);
        btn.textContent = err.message && err.message.length < 50 ? err.message : '追加に失敗しました';
        setTimeout(function(){ btn.textContent = origText; btn.disabled = false; }, 2500);
      });
    });
  }

  /* ============ INIT ============ */
  function init(){
    initScrollTrigger();
    initBundleCart();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode){
    document.addEventListener('shopify:section:load', function(){
      initScrollTrigger();
    });
  }
})();
